


















import { InjectReactive, Vue, Component } from 'vue-property-decorator';
import { BillingSetupService } from './service/billing-setup-service';

@Component({})
export default class PartnerContributionSelection extends Vue {
	@InjectReactive('billingSetupService') service!: BillingSetupService;

	public updateContributionTier(contributionTier: string) {
		this.service.updateContributionTier(contributionTier);
	}

	public get availablePartnerContributions(): { value: string; text: string }[] {
		if (
			this.service.partnerContributions === null ||
			!this.service.partnerContributions.contributionTiers
		) {
			return [];
		}
		return this.service.partnerContributions.contributionTiers!.map((contribution: string) => ({
			value: contribution,
			text: this.$options.filters!.titleCase(contribution),
		}));
	}
}
